import { render, staticRenderFns } from "./book-with-file.vue?vue&type=template&id=91f33b7a"
import script from "./book-with-file.vue?vue&type=script&lang=js"
export * from "./book-with-file.vue?vue&type=script&lang=js"
import style0 from "./book-with-file.vue?vue&type=style&index=0&id=91f33b7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports